// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3bynb","header":"ReportDetails_header__2YQWm","title":"ReportDetails_title__jpPHd","left":"ReportDetails_left__3KhG4"};